/* import Vue from 'vue';
import 'pusher-js';
import VueEcho from 'vue-echo';
import store from '@/store/index';

const token = store.getters['auth/token'];
    
Vue.use(VueEcho, {
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    wsHost: process.env.VUE_APP_WEBSOCKETS_HOST,
    wsPort: process.env.VUE_APP_WEBSOCKETS_PORT,
    authEndpoint: process.env.VUE_APP_API + '/api/broadcasting/auth',
    auth: {
        headers: {
            'Authorization': `Bearer ${token}`,
            Accept: 'application/json',
        }
    },
    disableStats: true,
});

export default Vue; */

import Vue from "vue";
import 'pusher-js';
import Echo from "laravel-echo";
import store from '@/store/index';

const token = store.getters['auth/token'];

const production: boolean = process.env.VUE_APP_ENV === 'production';

export var echoInstance = new Echo({
    broadcaster: 'pusher',
    key: process.env.VUE_APP_PUSHER_APP_KEY,
    cluster: process.env.VUE_APP_PUSHER_APP_CLUSTER,
    wsHost: process.env.VUE_APP_WEBSOCKETS_HOST,
    wsPort: production ? process.env.VUE_APP_WEBSOCKETS_PORT : 6001,
    wssPort: production ? process.env.VUE_APP_WEBSOCKETS_PORT : 6001,
    enabledTransports: ['ws', 'wss'],
    encrypted: production,
    authEndpoint: process.env.VUE_APP_API + '/api/broadcasting/auth',
    auth: {
        headers: {
            'Authorization': `Bearer ${token}`,
            Accept: 'application/json',
        }
    },
    disableStats: true,
});

Vue.prototype.$echo = echoInstance;

export default Vue;